export const SKELETON = {
  value: { width: 96, height: 24, radius: 8 },
};
